import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'address', 'city', 'postalCode', 'country']

  connect() {
    if (typeof google === 'undefined') return

    this.autocomplete = new google.maps.places.Autocomplete(this.inputTarget, {
      fields: ['address_components'],
      types: ['address'],
    })

    this.placeChangedListener = this.autocomplete.addListener('place_changed', () => this.#onPlaceChanged())
  }

  disconnect() {
    if (this.placeChangedListener) {
      google.maps.event.removeListener(this.placeChangedListener)
    }
  }

  #onPlaceChanged() {
    const place = this.autocomplete.getPlace()
    let streetNumber = ''
    let route = ''

    for (const component of place.address_components) {
      for (const type of component.types) {
        switch (type) {
          case 'street_number':
            streetNumber = component.long_name
            break
          case 'route':
            route = component.long_name
            break
          case 'locality':
            if (this.hasCityTarget) this.cityTarget.value = component.long_name
            break
          case 'postal_code':
            if (this.hasPostalCodeTarget) this.postalCodeTarget.value = component.short_name
            break
          case 'country':
            if (this.hasCountryTarget) this.countryTarget.value = component.short_name
            break
        }
      }
    }

    if (this.hasAddressTarget) {
      this.addressTarget.value = [streetNumber, route].filter(Boolean).join(' ')
    }
  }
}
